import React from 'react';
import { observer } from 'mobx-react';
import { ErrorViewTemplate } from 'themes/components';

function ErrorView(props) {
	return <ErrorViewTemplate {...props} />;
}

export default observer(ErrorView);
